module.exports = __webpack_public_path__ + "img/client-7.339321b4.png";